import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useRequest } from '@Contexts/Request';

import type { KitProductData } from '@Types/Kit';
import type { ProductData } from '@Types/Product';
import type { InfiniteData } from '@tanstack/react-query';

const useChangeKitQuantity = (mainId: number) => {
  const queryClient = useQueryClient();
  const { region, country } = useRequest();
  const key = ['kit-products', mainId, region, country];

  return useMutation({
    mutationKey: key,
    mutationFn: async (data: { product: ProductData; quantity?: number }) => {
      const { product, quantity } = data;

      if (typeof quantity === 'number') {
        return { ...product, quantity };
      }

      return product;
    },
    onSuccess(newProduct) {
      queryClient.setQueryData<InfiniteData<KitProductData>>(
        key,
        (data: InfiniteData<KitProductData>) => {
          const newPages = (data?.pages || []).map((page) => {
            const newProducts = page.changedProducts.map((product) => {
              if (product.id === newProduct.id) {
                return newProduct;
              }

              return { ...product, quantity: 0 };
            });
            return { ...page, changedProducts: newProducts };
          });
          return { ...data, pages: newPages };
        },
      );
    },
  });
};

export default useChangeKitQuantity;
